module.exports = __webpack_public_path__ + "77f192c53aabd1547ea6e4b721c8b1a2.jpg";